import React from 'react';
import { Grid, Stack, TextField, Typography } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import { useLocationPicker } from '../../hooks';
import type { ILocationPickerProps } from '../../interfaces';

export const LocationPicker = ({
  value,
  onChange,
  placeholder = 'Start typing a city...',
}: ILocationPickerProps) => {
  const picker = useLocationPicker(onChange);

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <TextField
          inputRef={picker.inputRef}
          placeholder={placeholder}
          defaultValue={value}
          autoComplete="off"
          fullWidth
          InputProps={{
            startAdornment: <PlaceIcon fontSize="small" color="disabled" sx={{ mr: 1 }} />,
          }}
      />

      <Grid container spacing={1.5}>
        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', ml: 0.5 }}>
              City
            </Typography>
            <TextField
                value={picker.locationInfo.city}
                placeholder="Enter city"
                onChange={(e) => picker.handleFieldChange('city', e.target.value)}
                size="small"
                fullWidth
            />
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', ml: 0.5 }}>
              State
            </Typography>
            <TextField
                value={picker.locationInfo.state}
                placeholder="Enter state"
                onChange={(e) => picker.handleFieldChange('state', e.target.value)}
                size="small"
                fullWidth
            />
          </Stack>
        </Grid>
      </Grid>

      <Grid container spacing={1.5}>
        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', ml: 0.5 }}>
              Country
            </Typography>
            <TextField
                value={picker.locationInfo.country}
                placeholder="Enter country"
                onChange={(e) => picker.handleFieldChange('country', e.target.value)}
                size="small"
                fullWidth
            />
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', ml: 0.5 }}>
              Postal Code
            </Typography>
            <TextField
                placeholder="Enter manually"
                value={picker.postcode}
                onChange={(e) => picker.handlePostcodeChange(e.target.value)}
                size="small"
                fullWidth
            />
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};
